<template>
  <v-autocomplete
    v-model="currentValue"
    v-bind="$attrs"
    :items="items"
    outlined
    dense
    clearable
    :multiple="multiple"
    :disabled="disabled"
    append-icon="mdi-chevron-down"
    item-text="text"
    item-value="value"
    required
    :no-data-text="$t('service.listIsEmpty')"
    :label="labelValue"
    :rules="rules"
    item-color="blue darken-1"
    v-on="$listeners"
  >
    <template #item="{item, attrs, on}">
      <v-list-item #default="{active}" v-bind="attrs" v-on="on">
        <v-list-item-action>
          <v-checkbox color="blue darken-1" :input-value="active" :ripple="false" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="d-flex align-center">
            <v-sheet v-if="!!item.tooltip" width="30" color="transparent">
              <TooltipWithIcon top size="22" text="none" :message="item.tooltip" />
            </v-sheet>
            <span>{{ $t(item.text) }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template #selection="{item, index}">
      <span v-if="index === 0">{{ $t(item.text) }}</span>
      <span v-if="index === 1" class="text-caption pl-2">
        (+{{ currentValue.length - 1 }} {{ $t('label.others') }})
      </span>
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'CustomAutocompleteWithTranslated',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Number],
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    labelValue() {
      return this.rules.length ? this.label + ' *' : this.label
    },
  },
}
</script>
